module.exports = __webpack_public_path__ + "img/product.1042fac0.png";